import { isAuthenticatedUser } from 'js/lib/user';

import GrowthAcquisition from 'bundles/epic/clients/GrowthAcquisition';

/**
 * Note: On May 15th, 2025 it was decided that variants 2 and 3 would shut down. They were pointed
 * to the control experience so that we could keep running variant 1 and collecting data. These utilities
 * (and corresponding tests) were updated to reflect that.
 *
 * We will retain the impression points - even the ones that are no longer useful - to not avoid changing anything
 * with the existing variant that's running
 */

export function getShouldShowUnregisteredOnboarding() {
  return !isAuthenticatedUser();
}

export function getShouldShowCourseraPlusMerchandisingPlacements() {
  if (isAuthenticatedUser()) {
    return GrowthAcquisition.get('useSubscriptionsForwardDiscoveryUserBased') !== 'control';
  }

  GrowthAcquisition.get('subscriptionsForwardDiscoverySessionBasedAaTest');
  GrowthAcquisition.get('useSubscriptionsForwardDiscoverySessionBased');
  return false;
}

export function previewShouldShowCourseraPlusMerchandisingPlacements() {
  if (isAuthenticatedUser()) {
    return GrowthAcquisition.preview('useSubscriptionsForwardDiscoveryUserBased') !== 'control';
  }

  GrowthAcquisition.preview('useSubscriptionsForwardDiscoverySessionBased');
  return false;
}

/**
 * @description For "start free trial" CTAs
 */
export function getShouldShowUpdatedEnrollmentCTAs() {
  if (isAuthenticatedUser()) {
    return GrowthAcquisition.get('useSubscriptionsForwardDiscoveryUserBased') !== 'control';
  }

  GrowthAcquisition.get('subscriptionsForwardDiscoverySessionBasedAaTest');
  GrowthAcquisition.get('useSubscriptionsForwardDiscoverySessionBased');
  return false;
}

export function getShouldShowCourseraPlusEntrypointInNav() {
  if (isAuthenticatedUser()) return false;

  GrowthAcquisition.get('subscriptionsForwardDiscoverySessionBasedAaTest');
  GrowthAcquisition.get('useSubscriptionsForwardDiscoverySessionBased');
  return false;
}

/**
 * @description For XDP changes, C+ entrypoint in nav, C+ landing page redesign (if applicable), C+ annual 7 day free trial
 */
export function getShouldShowXDPAndCourseraPlusLandingPageChanges() {
  if (isAuthenticatedUser()) {
    return GrowthAcquisition.get('useSubscriptionsForwardDiscoveryUserBased') !== 'control';
  }

  GrowthAcquisition.get('subscriptionsForwardDiscoverySessionBasedAaTest');
  GrowthAcquisition.get('useSubscriptionsForwardDiscoverySessionBased');
  return false;
}

export function getShouldShowEnrollmentFlowChanges() {
  if (!isAuthenticatedUser()) return false;

  const valueFromEpic = GrowthAcquisition.get('useSubscriptionsForwardDiscoveryUserBased');
  return valueFromEpic === 'variant2' || valueFromEpic === 'variant3';
}

/**
 * @description For checkout page redesign and toggle
 */
export function getShouldShowCheckoutPageChanges() {
  if (!isAuthenticatedUser()) return false;

  return GrowthAcquisition.get('useSubscriptionsForwardDiscoveryUserBased') === 'variant3';
}

/**
 * @description For post-purchase upsell redesign, post-purchase confirmation, profile treatment
 */
export function previewShouldShowPostPurchaseChanges() {
  if (!isAuthenticatedUser()) return false;

  const valueFromEpic = GrowthAcquisition.preview('useSubscriptionsForwardDiscoveryUserBased');
  return valueFromEpic === 'variant2' || valueFromEpic === 'variant3';
}
